export default __webpack_public_path__ + "static/media/mobile_forbidden_icon.6843ee79.png";